import {getOverflowHiddenAncestor} from "./ai-actions-utils";

const TOOLTIP_SPACE_FROM_EDGE = 50;
let isAlreadyShowing = false;

export function showAiActionsTooltip(buttonElement: Element): Promise<void> {
  return new Promise((resolve) => {
    const contents = `
    <style nonce="CSP_STYLE_NONCE_PLACEHOLDER">
        .ai-actions-tooltip-frame {
            background-color: rgb(9, 32, 54);
            border-radius: 5px;
            padding: 20px;
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
            width: 380px;
            display: flex;
            flex-direction: row;
            position: absolute;

            right: 10px;
            transform: translateX(50%);
            z-index: 1000000;
        }

        .ai-actions-tooltip-open-upwards .ai-actions-tooltip-frame {
            bottom: 33px;
        }

        .ai-actions-tooltip-open-downwards .ai-actions-tooltip-frame {
            top: 33px;
        }

        .ai-actions-tooltip-frame:before {
            content: ' ';
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
            background-color: rgb(9, 32, 54);
            position: absolute;
            width: 12px;
            height: 12px;
            left: calc(50% - 22px);
            transform: rotate(45deg);
        }

        .ai-actions-tooltip-open-upwards .ai-actions-tooltip-frame:before {
            top: calc(100% - 7px);
        }

        .ai-actions-tooltip-open-downwards .ai-actions-tooltip-frame:before {
            bottom: calc(100% - 7px);
        }

        .ai-actions-tooltip-icon {
            width: 32px;
            height: 32px;
            background-image: url('/assets/images/icons/ai-actions/tooltip-icon.svg');
            background-repeat: no-repeat;
            background-size: contain;
        }

        .ai-actions-tooltip-body {
            flex: 1;
            padding: 3px 15px;
        }

        .ai-actions-tooltip-title {
            color: #fff;
            font-size: 22px;
            font-weight: 400;
            padding-bottom: 12px;
        }

        .ai-actions-tooltip-desc {
            color: #fff;
            font-weight: 500;
            font-size: 14px;
        }

        .ai-actions-tooltip-x-button {
          position: relative;
          width: 13px !important;
          height: 13px !important;
          background-color: transparent;
          border: none;
          cursor: pointer;
          padding: 0 !important;
        }

        .ai-actions-tooltip-x-button::before,
        .ai-actions-tooltip-x-button::after {
          content: "";
          position: absolute;
          top: 50%;
          left: 50%;
          width: 100%;
          height: 2px;
          background-color: #fff;
          transform-origin: center;
          border: none;
        }

        .ai-actions-tooltip-x-button::before {
          transform: translate(-50%, -50%) rotate(45deg);
        }

        .ai-actions-tooltip-x-button::after {
          transform: translate(-50%, -50%) rotate(-45deg);
        }
    </style>

    <div class="ai-actions-tooltip-frame">
        <div class="ai-actions-tooltip-icon">
        </div>
        <div class="ai-actions-tooltip-body">
          <div class="ai-actions-tooltip-title">
              Check out Covercy AI!
          </div>
          <div class="ai-actions-tooltip-desc">
            <p>
                We just launched a new Covercy AI feature to help you write better texts to your investors.
            </p>
            <p>
              To use it, highlight the text you want to refine, click the Covercy AI button,
              and choose to improve, make longer, shorter, or any other transformation you need.
            </p>
          </div>
        </div>
        <button class="ai-actions-tooltip-x-button"></button>
    </div>
  `;

    if (isAlreadyShowing) {
      return;
    }
    isAlreadyShowing = true;

    const dialogRoot = document.createElement('div');
    dialogRoot.className = 'ai-actions-tooltip-root';
    dialogRoot.innerHTML = contents;

    buttonElement.appendChild(dialogRoot);

    dialogRoot.querySelector('.ai-actions-tooltip-x-button')?.addEventListener('click', () => {
      resolve();
      dialogRoot.remove();
      isAlreadyShowing = false;
    });

    requestAnimationFrame(() => {
      const tooltipHeight = dialogRoot.querySelector('.ai-actions-tooltip-frame')?.clientHeight;
      let ancestor = buttonElement.closest('[mat-dialog-content]');

      if (!ancestor) {
        ancestor = getOverflowHiddenAncestor(buttonElement);
      } 

      const topEdge = Math.max(ancestor.getBoundingClientRect().top, 0);
      const buttonTop = buttonElement.getBoundingClientRect().top;

      // if element is not visible on the screen show the tooltip Upwards
      if (tooltipHeight && (buttonTop - topEdge < tooltipHeight + TOOLTIP_SPACE_FROM_EDGE)) {
        dialogRoot.classList.add('ai-actions-tooltip-open-downwards');
      } else {
        dialogRoot.classList.add('ai-actions-tooltip-open-upwards');
      }
    });

  });
}
